import { buildTranslate } from 'locales'
import React from 'react'
import CmsPage from 'scenes/Cms/components/CmsPage'
import Footer from '../_shared/Footer'
import Sidebar from '../_shared/Sidebar'
// import { useAppNavigationHamburgerNav } from './hooks'

const t = buildTranslate('cms.content.app_navigation.hamburger_nav')

const HamburgerNav: React.FC = () => {
  // const { state, actions } = useAppNavigationHamburgerNav()

  return (
    <CmsPage
      title={t('title')}
      description={t('description')}
      sidebar={<Sidebar />}
    >
      <div className={'p-m white-bkg mb-l'}>
        {/* TODO: Add form components for hamburger navigation configuration */}
        <div className="text-center text-muted">
          <p>{t('coming_soon')}</p>
        </div>
      </div>
      <Footer />
    </CmsPage>
  )
}

export default HamburgerNav
